module.exports = __webpack_public_path__ + "media/images/emblems/Deisswil_bei_Muenchenbuchsee-coat_of_arms-aeb5ec2034aa384d6d305622b9d571ba.svg";